module.exports = __webpack_public_path__ + "img/23.c6be1463.svg";